import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import circleWood from "../../../assets/images/circle_wood_empty.png";
import btnBanafsh from "../../../assets/images/btn_banafsh_setting.png";
import usernameBorder from "../../../assets/images/username_edt.png";
import blueButton from "../../../assets/images/btn_blue_radius_setting.png";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../Common/Dialog";
import Dialog from "@material-ui/core/Dialog";
import AvatarDialog from "./AvatarDialog";
import axios from "axios";
import {avatarList, walletReqPay} from "../../../Utility/Url";
import {data} from "../../../Store/Actions/DataAction";
import {stars} from "../../../Store/Actions/StarsAction";
import {connect} from "react-redux";
import ProfileDialog from "./ProfileDialog";
import {withRouter} from "react-router-dom";
class UserDetail extends React.Component{
    constructor() {
        super();
        this.state={
            avatarDialog:null,
            showDialog:false,
            avatars:null,
            userAvatar:'',
            userName:'',
            showEditDialog:false
        }
    }
    handleEditDialog=()=>{
        this.props.history.push('/settings/profileedit')
        return
        this.setState({
            showEditDialog:true
        })
    }
    handleDialog=async()=>{
        this.props.history.push('/settings/avatar')
        return
        this.props.stars(true)
        this.setState({
            showDialog:true
        })
        await axios.get(avatarList)
            .then(res => {
                const {data}=res
                this.setState({
                    avatars:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    checkLoading=()=>{
        if (this.props.UserData.userData!=null)
            if (this.state.userAvatar===''){
                this.setState({
                    userAvatar:this.props.UserData.userData.userInfo.avatar,
                    userName:this.props.UserData.userData.userInfo.name
                })
                clearInterval(this.state.interval)
            }
    }
    dataInterval=() =>{
        const interval =  setInterval(this.checkLoading, 100);
        this.setState({
            interval:interval
        });
    }
    componentDidMount() {
        this.dataInterval()
    }
    render() {
        const handleClose=(()=>{
            this.props.stars(false)
            this.setState({
                showDialog:false
            })
        })
        const handleEditDialogClose=(()=>{
            this.setState({
                showEditDialog:false
            })
        })
        const {avatars}=this.state
        const {userAvatar,userName}=this.state
        return(
            <Grid item sm={12} xs={12} justify={'space-between'} container>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <AvatarDialog closeDialog={handleClose} avatars={avatars}/>
                    </DialogContent>
                </Dialog>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showEditDialog}
                    onClose={handleEditDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <ProfileDialog closeDialog={handleEditDialogClose}/>
                    </DialogContent>
                </Dialog>
                <Grid sm={7} xs={7} justify={'space-around'} className='username-section' container alignItems='center'
                      onClick={this.handleEditDialog}
                      style={{
                          backgroundImage: `url("${usernameBorder}")`,
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition:'center',
                          padding:'5px'
                      }}
                      direction={"row-reverse"}
                >
                    <Grid sm={5} xs={5} justify={'center'}
                          container alignItems='center'
                    >
                        <p className='username-section-text'>
                            {userName}
                        </p>
                    </Grid>
                    <Grid sm={5} xs={5} justify={'center'}
                          container alignItems='center'
                          style={{
                              backgroundImage: `url("${blueButton}")`,
                              backgroundSize: 'contain',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition:'center'
                          }}
                    >
                        {/*<p className='username-section-blue-button-text'>*/}
                        <p className='username-section-blue-button-text'>
                            ویرایش
                        </p>
                    </Grid>

                </Grid>
                <Grid item sm={4} xs={4} alignItems={"center"} justify={'center'} className='wooden-circle-section clickable' container
                      onClick={this.handleDialog}>
                    <Grid item container alignItems={"center"} justify={'center'}
                          style={{width:'150px',height:'150px',position:'relative'}}
                    >
                        <img src={circleWood} className='wooden-circle-section-image' alt=""/>
                        {
                            userAvatar!==''&&
                            <img src={userAvatar} className='wooden-circle-section-profile' alt=""/>
                        }
                        <img src={btnBanafsh} className='wooden-circle-section-purple-image' alt=""/>
                        <p className='wooden-circle-section-text'>تغییر</p>
                    </Grid>

                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    Stars:state.Stars
})
export default connect(mapStateToProps,{data,stars})(withRouter(UserDetail))